"use client";

import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function EditProfileAndEducation() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    gender: "",
    city: "",
    dob: "",
    age: "",
    height: "",
    weight: "",
    fathersName: "",
    mothersName: "",
    address: "",
    jobType: "",
    companyName: "",
    salary: "",
    totalExperience: "",
    degree: "",
    school: "",
    college: "",
    hobbies: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const basicFields = [
    { id: "name", type: "text", label: "Name", placeholder: "Enter your full name" },
    { id: "email", type: "email", label: "Email", placeholder: "Enter your Email ID" },
    { id: "phone", type: "tel", label: "Phone", placeholder: "Enter your Phone Number" },
    { id: "password", type: "password", label: "Password", placeholder: "Enter your Password" },
  ];

  const advancedFields = [
    { id: "gender", type: "text", label: "Gender" },
    { id: "city", type: "text", label: "City" },
    { id: "dob", type: "text", label: "Date of Birth" },
    { id: "age", type: "text", label: "Age" },
    { id: "height", type: "text", label: "Height" },
    { id: "weight", type: "text", label: "Weight" },
    { id: "fathersName", type: "text", label: "Father's Name" },
    { id: "mothersName", type: "text", label: "Mother's Name" },
    { id: "address", type: "text", label: "Address", fullWidth: true },
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 py-8 min-h-screen space-y-12">

      <Link to="#" className="flex items-center text-base text-black font-medium mt-4">
        <ArrowLeft className="h-6 w-6 mr-2" />
        Edit my Profile
      </Link>

      {/* Profile Picture & Name */}
      <div className="flex flex-col items-center">
        <div className="w-36 h-36 rounded-full overflow-hidden bg-pink-200 mb-2">
          <img src="m_header.jpg" alt="Profile" className="w-full h-full object-cover" />
        </div>
        <div className="flex items-center gap-2">
          <button className="text-gray-600">
            <img src="/edit.png" className="h-5 w-5" />
          </button>
          <h2 className="text-xl font-medium">Ashley emyy</h2>
        </div>
      </div>

      {/* Profile Form */}
      <div className="space-y-6">
        <h3 className="text-lg font-bold text-[#66451C]">Edit My Profile</h3>
        <div className="border border-b-gray-200 shadow"></div>

        <div className="grid grid-cols-1 gap-4">
          {basicFields.map((field) => (
            <div key={field.id} className="space-y-1">
              <label htmlFor={field.id} className="text-sm font-medium">
                {field.label}:
              </label>
              <input
                type={field.type}
                id={field.id}
                name={field.id}
                placeholder={field.placeholder}
                value={formData[field.id]}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-lg placeholder:text-[#737373] placeholder:text-sm bg-transparent"
              />
            </div>
          ))}
        </div>

        <div className="h-0.5 rounded-full bg-gradient-to-r from-[#DA5357] via-[#B93396] to-[#B9733D] my-6 "></div>

        {/* Advanced Fields */}
        <div>
          <div className="flex flex-col space-y-1">
            <span className="text-sm font-medium">Basic Info</span>
            <span className="text-base font-bold text-[#66451C]">Advanced Info</span>
     
          </div>
          <div className="border border-b-gray-200 shadow"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {advancedFields.map((field) => (
              <div key={field.id} className={`space-y-1 ${field.fullWidth ? "md:col-span-2" : ""}`}>
                <label htmlFor={field.id} className="text-sm font-medium">
                  {field.label}:
                </label>
                <input
                  type={field.type}
                  id={field.id}
                  name={field.id}
                  value={formData[field.id]}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-lg bg-transparent"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="h-0.5 rounded-full bg-gradient-to-r from-[#DA5357] via-[#B93396] to-[#B9733D] my-6 "></div>

      {/* Job & Education Form */}
      <div className="space-y-6">
        <div className="flex flex-col space-y-1">
            <span className="text-sm font-medium">Job details</span>
            <span className="text-base font-bold text-[#66451C]">Job & Education</span>
          </div>
          <div className="border border-b-gray-200 shadow"></div>
        <div className="space-y-4">
          <div className="space-y-1">
            <label htmlFor="jobType" className="text-sm font-medium text-gray-700">Job type:</label>
            <input
              type="text"
              id="jobType"
              name="jobType"
              placeholder="Enter your Job role"
              value={formData.jobType}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
            />
          </div>

          <div className="space-y-1">
            <label htmlFor="companyName" className="text-sm font-medium text-gray-700">Company name:</label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              placeholder="Enter your Company name"
              value={formData.companyName}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label htmlFor="salary" className="text-sm font-medium text-gray-700">Salary:</label>
              <input
                type="text"
                id="salary"
                name="salary"
                placeholder="Enter your Salary"
                value={formData.salary}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
              />
            </div>
            <div className="space-y-1">
              <label htmlFor="totalExperience" className="text-sm font-medium text-gray-700">Experience:</label>
              <input
                type="text"
                id="totalExperience"
                name="totalExperience"
                placeholder="Enter your total experience"
                value={formData.totalExperience}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
              />
            </div>
          </div>

          <div className="space-y-1">
            <label htmlFor="degree" className="text-sm font-medium text-gray-700">Degree:</label>
            <input
              type="text"
              id="degree"
              name="degree"
              placeholder="Enter your Degree"
              value={formData.degree}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label htmlFor="school" className="text-sm font-medium text-gray-700">School:</label>
              <input
                type="text"
                id="school"
                name="school"
                placeholder="Enter your School name"
                value={formData.school}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
              />
            </div>
            <div className="space-y-1">
              <label htmlFor="college" className="text-sm font-medium text-gray-700">College:</label>
              <input
                type="text"
                id="college"
                name="college"
                placeholder="Enter your College name"
                value={formData.college}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-lg bg-transparent placeholder:text-[#737373] placeholder:text-sm"
              />
            </div>
          </div>

       <div className="h-0.5 rounded-full bg-gradient-to-r from-[#DA5357] via-[#B93396] to-[#B9733D] my-6 "></div>


          <div className="space-y-1">
            <label htmlFor="hobbies" className="text-sm font-medium text-gray-700">Hobbies:</label>
            <textarea
              id="hobbies"
              name="hobbies"
              placeholder="Enter your Hobbies"
              value={formData.hobbies}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg bg-transparent resize-none placeholder:text-[#737373] placeholder:text-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
